import React, { memo } from 'react';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import { Theme } from '../../interfaces/enums/Theme.enum';
import Grid from '../Utils/Grid/Grid';
import Container from '../Utils/Container/Container';
import Col from '../Utils/Col/Col';
import QuoteFormTabBarTab, {
  QuoteFormTabBarTabStatus,
} from './QuoteFormTabBarTab';
import { LinkProps } from '../../interfaces/LinkProps.interface';
import QuoteTabBarLoadingState from './QuoteTabBarLoadingState';

interface QuoteFormTabBarProps {
  tabOne: string | LinkProps[];
  tabTwo: string | LinkProps[];
  tabThree: string | LinkProps[];
  activeTabNumber: number;
}

const getTabNumber = (tabIndex: number) => tabIndex + 1;

const getMobileTabLabel = (
  tabOne: string | LinkProps[],
  tabTwo: string | LinkProps[],
  tabThree: string | LinkProps[],
  activeTabNumber: number
): string => {
  if (activeTabNumber === 1) return getTabLabel(tabOne);
  if (activeTabNumber === 2) return getTabLabel(tabTwo);
  if (activeTabNumber === 3) return getTabLabel(tabThree);
  return '';
};

const getTabLabel = (tab: string | LinkProps[]): string => {
  if (typeof tab === 'string') return tab;
  const tabLink: LinkProps = tab[0];
  return tabLink.label;
};

const getTabLink = (tab: string | LinkProps[]): string | undefined => {
  if (typeof tab === 'string') return undefined;
  const tabLink: LinkProps = tab[0];
  return tabLink.link?.cached_url;
};

const getTabBarTabTheme = (
  tabNumber: number,
  activeTabNumber: number
): Theme => {
  if (tabNumber === activeTabNumber) return Theme.DARK;
  return Theme.LIGHT;
};

const QuoteFormTabBar: React.FC<QuoteFormTabBarProps> = ({
  tabOne,
  tabTwo,
  tabThree,
  activeTabNumber,
}) => {
  return (
    <section>
      {/*-- mobile --*/}
      <div className="block h-32 md:hidden">
        <QuoteFormTabBarTab
          tabNumber={activeTabNumber}
          activeTabNumber={activeTabNumber}
          label={getMobileTabLabel(tabOne, tabTwo, tabThree, activeTabNumber)}
          link={undefined}
          tabStatus={QuoteFormTabBarTabStatus.ACTIVE}
          theme={Theme.DARK}
        />
      </div>

      {/*-- tablet and desktop --*/}
      <div className="hidden md:block">
        <Container startingBreakpoint="lg">
          <Grid className="h-32" gapX="gap-x-0">
            {[tabOne, tabTwo, tabThree].map(
              (tab: string | LinkProps[], index: number) => (
                <Col span={{ default: 4 }} key={index}>
                  <QuoteFormTabBarTab
                    tabNumber={getTabNumber(index)}
                    activeTabNumber={activeTabNumber}
                    label={getTabLabel(tab)}
                    url={getTabLink(tab)}
                    theme={getTabBarTabTheme(
                      getTabNumber(index),
                      activeTabNumber
                    )}
                  />
                </Col>
              )
            )}
          </Grid>
        </Container>
      </div>
    </section>
  );
};

export default memo(withBlokWrapper(QuoteFormTabBar, Theme.LIGHT));
